// extracted by mini-css-extract-plugin
export default {"container":"xDA56lm6qQGVWi4MosSa","bar":"pQtFTxjKUbSKUJosOqxz","labels":"nvQYXpXlPn4nqaSRlszd","totalLabel":"VYyIZWq7JvrmEzUk1Eo5","emptyState":"kKY3Ex8HKJabymCvGWV6"};